module.exports = __webpack_public_path__ + "static/img-hero-stemi-lab-edae77e82628ee42249c3bb4e5bd2f6d.png";